import { Component, OnInit, OnDestroy } from "@angular/core";
import { GridDataResult, PageChangeEvent } from "@progress/kendo-angular-grid";
import {
  ApiRequest,
  Filter,
  FilterComposit,
  FilterPredicate,
  Sort,
  SortCondition,
  PageInfo,
  ApiResponse
} from "../../model/api-request";
import { AdvancedSearchAll } from "src/app/model/advancedSearchAll";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { AirportAdvancedSearchAllService } from "src/app/service/airport-advanced-search-all.service";
import { AirportAdvancedSearchExcludeHardSurfaceService } from "src/app/service/airport-advanced-search-exclude-hard-surface.service";
import { AirportAdvancedSearchHardSurfaceOnlyService } from "src/app/service/airport-advanced-search-hard-surface-only.service";
import { CurrentAptService } from "src/app/service/current-apt.service";
import { process, State } from '@progress/kendo-data-query';
import { Observable } from 'rxjs/Observable';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { isNumeric } from "rxjs/util/isNumeric";
import { items } from 'src/app/model/items';
import {ExcelService} from '../../service/excel.service';
import { AdvancedSearchExport } from "src/app/model/advancedSearchExport";
import { JsonPipe } from '@angular/common';
import { ConfigService } from "src/app/service/config.service";

@Component({
  selector: "app-airport-advancedsearch",
  templateUrl: "./airport-advancedsearch.component.html",
  styleUrls: ["./airport-advancedsearch.component.css"]
})
export class AirportAdvancedsearchComponent implements OnInit, OnDestroy {
  public showSearch: boolean;
  public showGrid: boolean;
  public advancedSearchAll = new AdvancedSearchAll();
  public apiRequest: ApiRequest;
  public apiResponse: ApiResponse;
  public filterOperation: number;
  public filterStringOperation: string;
  public errormsg: string = '';
  public projectColor: string;
  public userModified: boolean = false;

  gridView: GridDataResult = null;
  items: any[] = null;
  public totalRecords: number = 0;
  public pageSize = 500;
  skip: number = 0;
  navigationSubscription;

  public reportRouter: string;
  public multiple = false;
  public allowUnsort = true;
  public sort: SortDescriptor[] = [{
    field: 'airportName',
    dir: 'asc'
  }];
  public exportItems: AdvancedSearchExport[] = [];
  public exportItemsNoDups: AdvancedSearchExport[] = [];
  constructor(
    private airportAdvancedSearch: AirportAdvancedSearchAllService,
    private airportExcludeHardSurface: AirportAdvancedSearchExcludeHardSurfaceService,
    private airportHardSurfaceOnly: AirportAdvancedSearchHardSurfaceOnlyService,
    private cas: CurrentAptService,
    private router: Router,
    private excelService: ExcelService,
    config: ConfigService

  ) {
    this.projectColor = config.values.projectColor;
    this.reportRouter = config.values.reportRouter;
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.showSearch = true;
        this.showGrid = false;
        this.onReset();
      }
    });

  }

  ngOnInit() {
    this.showSearch = true;
    this.showGrid = false;
    this.gridView = null;
    this.totalRecords = 0;
    this.onReset();
    //this.getTotalRecords();
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  public validateForm() {
    // used for form validation if not entered anything
    if(this.advancedSearchAll.airportIdentifier) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.airportName) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.associatedCity) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.fuel) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.based) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.operationsTotal) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.runwayLength) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.baseRunwayElevation) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.runwayWidth) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.surfaceTypeCondition) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.aPhysicalElevOperator) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.baseFar77CategoryDesc) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.baseCloseInObstruction) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.baseRwyMarkingTypeDesc) {
      this.userModified=true;
    }

    if(this.advancedSearchAll.baseRwyMarkingCondition) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.surfaceTreatmentDesc) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.unicom) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.ctrlTwr) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.npiasHubType) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.ado) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.part139) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.ownership) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.stateCode) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.airportUse) {
      this.userModified=true;
    }
    if(this.advancedSearchAll.surfaceTypeHard !== '1') {
      this.userModified=true;
    }
    if(this.advancedSearchAll.aBasedMf  !== '0') {
      this.userModified=true;
    }
    if(this.advancedSearchAll.aOperationsMf !== '0') {
      this.userModified=true;
    }
    if(this.advancedSearchAll.aRunwayLengthMf !== '0') {
      this.userModified=true;
    }
    if(this.advancedSearchAll.aRunwayWidthMf !== '0') {
      this.userModified=true;
    }
    if(this.advancedSearchAll.region){
      this.userModified=true;
    }
    if(this.advancedSearchAll.aSurfaceCondition){
      this.userModified=true;
    }
    if(this.advancedSearchAll.ownerInfo){
      this.userModified=true;
    }
    if(this.advancedSearchAll.managerInfo){
      this.userModified=true;
    }
    if(this.advancedSearchAll.nonNpias){
      this.userModified=true;
    }
    if(this.advancedSearchAll.commercialService){
      this.userModified=true;
    }
    if(this.advancedSearchAll.primary){
      this.userModified=true;
    }
    if(this.advancedSearchAll.reliever){
      this.userModified=true;
    }
    if(this.advancedSearchAll.generalAvaition){
      this.userModified=true;
    }
    if(this.advancedSearchAll.national){
      this.userModified=true;
    }
    if(this.advancedSearchAll.regional){
      this.userModified=true;
    }
    if(this.advancedSearchAll.local){
      this.userModified=true;
    }
    if(this.advancedSearchAll.basic){
      this.userModified=true;
    }
    if(this.advancedSearchAll.unclassified){
      this.userModified=true;
    }
    if(!this.userModified){
      //this.errormsg += "Please select a value in the Advanced Search. ";
    }

// finished the form verification if anything is typed
    if (this.advancedSearchAll.runwayLength  ) {
      if(!isNumeric(this.advancedSearchAll.runwayLength)){
        this.errormsg += "Please enter a numeric value for the Runway length. ";
      }
      if (this.advancedSearchAll.aRunwayLengthMf === "0" ) {
        this.errormsg += "Please select the Runway length operator. ";
      }
    }
    if (this.advancedSearchAll.runwayWidth) {
      if(!isNumeric(this.advancedSearchAll.runwayWidth)){
        this.errormsg += "Please enter a numeric value for the Runway Width. ";
      }
      if (this.advancedSearchAll.aRunwayWidthMf === "0") {
        this.errormsg += "Please select the Runway width operator. ";
      }
    }
    if (this.advancedSearchAll.based) {
      if(!isNumeric(this.advancedSearchAll.based)){
        this.errormsg += "Please enter a numeric value for the based Aircraft. ";
      }
      if (this.advancedSearchAll.aBasedMf === "0") {
        this.errormsg += "Please select the based Aircraft operator. ";
      }
    }
    if (this.advancedSearchAll.operationsTotal) {
      if(!isNumeric(this.advancedSearchAll.operationsTotal)){
        this.errormsg += "Please enter a numeric value for the Total Operations. ";
      }
      if (this.advancedSearchAll.aOperationsMf === "0") {
        this.errormsg += "Please select the total operations operator. ";
      }
    }
    if (this.advancedSearchAll.baseRunwayElevation) {
      if(!isNumeric(this.advancedSearchAll.baseRunwayElevation)){
        this.errormsg += "Please enter a numeric value for the Runway Elevation. ";
      }
      if (this.advancedSearchAll.aPhysicalElevOperator === "") {
        this.errormsg += "Please select the physical elevation operator. ";
      }
    }
  }

  getTotalRecords(evnt) {
    this.totalRecords = 0;
    this.showSearch = true;
    this.showGrid = false;
    var elem = evnt.target;
    var oldValue = null;
    var elemType = elem.tagName.toLowerCase();
    if(elem.hasAttribute("oldvalue")) oldValue=elem.getAttribute("oldvalue");
    
    if(oldValue == null){
      if(elemType=="input"){
        if (elem.type=='checkbox') oldValue=false;
        else if(elem.type=='text') oldValue='';
      }
      else if(elemType=="select"){
        oldValue = 0;
      }
    }

    if(elemType=="input"){
      if (elem.type=='checkbox')  {elem.setAttribute('oldvalue', elem.checked ); if(oldValue==elem.checked) return;}
      else if(elem.type=='text') {elem.setAttribute('oldvalue', elem.value ); if(oldValue==elem.value) return;}
    }
    else if(elemType=="select"){
      elem.setAttribute('oldvalue', elem.selectedIndex );
      if(oldValue == elem.selectedIndex) return;
    }

    
    
    this.apiRequest = new ApiRequest();
    //this.apiRequest.filter = new Filter("And");
    //this.apiRequest.filterItems = [];
    var filterPredicateAirportIdentifier: Array<FilterPredicate>;
    var filterPredicateAirportName: Array<FilterPredicate>;
    var filterPredicateAssociatedCity: Array<FilterPredicate>;
    var filterPredicateFUEL: Array<FilterPredicate>;
    var filterPredicateOtherServices: Array<FilterPredicate>;
    var filterPredicateBased: Array<FilterPredicate>;
    var filterPredicateOperationsTotal: Array<FilterPredicate>;
    var filterPredicateRunwayLength: Array<FilterPredicate>;
    var filterPredicateBaseRunwayElevation: Array<FilterPredicate>;
    var filterPredicateRunwayWidth: Array<FilterPredicate>;
    var filterPredicateSurfaceTypeCondition: Array<FilterPredicate>;
    var filterPredicateBaseFar77CategoryDesc: Array<FilterPredicate>;
    var filterPredicateBaseCloseInObstruction: Array<FilterPredicate>;
    var filterPredicateBaseRwyMarkingTypeDesc: Array<FilterPredicate>;
    var filterPredicateBaseRwyMarkingCondition: Array<FilterPredicate>;
    var filterPredicateSurfaceTreatmentDesc: Array<FilterPredicate>;
    var filterPredicateUnicom: Array<FilterPredicate>;
    var filterPredicateCtrlTwr: Array<FilterPredicate>;
    var filterPredicateNpiasHubType: Array<FilterPredicate>;
    var filterPredicateAdo: Array<FilterPredicate>;
    var filterPredicatePart139: Array<FilterPredicate>;
    var filterPredicateOwnership: Array<FilterPredicate>;
    var filterPredicateStateCode: Array<FilterPredicate>;
    var filterPredicateAirportUse: Array<FilterPredicate>;
    var filterPredicateRegion: Array<FilterPredicate>;
    var filterPredicateSurfaceCondition: Array<FilterPredicate>;
    var filterPredicateASSETRank: Array<FilterPredicate>;
    var filterPredicateServiceLevel: Array<FilterPredicate>;
    var filterCompositArray: Array<FilterComposit>;
    var sortConditionArray: Array<SortCondition>;

      // input fields
      filterCompositArray = [];
      if (this.advancedSearchAll.airportIdentifier) {
        //this.apiRequest.filterItems.push(new FilterItems("AirportIdentifier", 8, "String", this.advancedSearchAll.airportIdentifier));
        filterPredicateAirportIdentifier = [new FilterPredicate('AirportIdentifier', 'String', this.advancedSearchAll.airportIdentifier,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateAirportIdentifier, 'Or'));
      }

      if (this.advancedSearchAll.airportName) {
        //this.apiRequest.filterItems.push(new FilterItems("AirportName", 8, "String",this.advancedSearchAll.airportName));
        filterPredicateAirportName = [new FilterPredicate('AirportName', 'String', this.advancedSearchAll.airportName,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateAirportName, 'Or'));
      }

      if (this.advancedSearchAll.associatedCity) {
        //this.apiRequest.filterItems.push(new FilterItems("AssociatedCity", 8, "String", this.advancedSearchAll.associatedCity));
        filterPredicateAssociatedCity = [new FilterPredicate('AssociatedCity', 'String', this.advancedSearchAll.associatedCity,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateAssociatedCity, 'Or'));
      }
      if (this.advancedSearchAll.fuel) {
        //this.apiRequest.filterItems.push(new FilterItems("FUEL", 8, "String", this.advancedSearchAll.fuel));
        filterPredicateFUEL = [new FilterPredicate('FUEL', 'String', this.advancedSearchAll.fuel,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateFUEL, 'Or'));
      }
      if (this.advancedSearchAll.otherServices) {
        //this.apiRequest.filterItems.push(new FilterItems("OtherServices", 8, "String", this.advancedSearchAll.otherServices));
        filterPredicateOtherServices = [new FilterPredicate('OtherServices', 'String', this.advancedSearchAll.otherServices,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateOtherServices, 'Or'));
      }
      if (this.advancedSearchAll.based) {
        if (this.advancedSearchAll.aBasedMf == "1") {
          this.filterStringOperation = 'IsEqualTo';
        }
        if (this.advancedSearchAll.aBasedMf == "2") {
          this.filterStringOperation = 'IsGreaterThan';
        }
        if (this.advancedSearchAll.aBasedMf == "3") {
          this.filterStringOperation = 'IsGreaterThanOrEqualTo';
        }
        if (this.advancedSearchAll.aBasedMf == "4") {
          this.filterStringOperation = 'IsLessThan';
        }
        if (this.advancedSearchAll.aBasedMf == "5") {
          this.filterStringOperation = 'IsLessThanOrEqualTo';
        }
        //this.apiRequest.filterItems.push(new FilterItems("Based", this.filterOperation, "Integer", this.advancedSearchAll.based));
        filterPredicateBased = [new FilterPredicate('Based', 'Integer', this.advancedSearchAll.based, this.filterStringOperation)];
        filterCompositArray.push(new FilterComposit(filterPredicateBased, 'Or'));
      }
      if (this.advancedSearchAll.operationsTotal) {
        if (this.advancedSearchAll.aOperationsMf == "1") {
          this.filterStringOperation = 'IsEqualTo';
        }
        if (this.advancedSearchAll.aOperationsMf == "2") {
          this.filterStringOperation = 'IsGreaterThan';
        }
        if (this.advancedSearchAll.aOperationsMf == "3") {
          this.filterStringOperation = 'IsGreaterThanOrEqualTo';
        }
        if (this.advancedSearchAll.aOperationsMf == "4") {
          this.filterStringOperation = 'IsLessThan';
        }
        if (this.advancedSearchAll.aOperationsMf == "5") {
          this.filterStringOperation = 'IsLessThanOrEqualTo';
        }
        //this.apiRequest.filterItems.push(new FilterItems("OperationsTotal", this.filterOperation, "Integer", this.advancedSearchAll.operationsTotal));
        filterPredicateOperationsTotal = [new FilterPredicate('OperationsTotal', 'Integer', this.advancedSearchAll.operationsTotal, this.filterStringOperation)];
        filterCompositArray.push(new FilterComposit(filterPredicateOperationsTotal, 'Or'));
      }
      if (this.advancedSearchAll.runwayLength) {
        if (this.advancedSearchAll.aRunwayLengthMf == "1") {
          this.filterStringOperation = 'IsEqualTo';
        }
        if (this.advancedSearchAll.aRunwayLengthMf == "2") {
          this.filterStringOperation = 'IsGreaterThan';
        }
        if (this.advancedSearchAll.aRunwayLengthMf == "3") {
          this.filterStringOperation = 'IsGreaterThanOrEqualTo';
        }
        if (this.advancedSearchAll.aRunwayLengthMf == "4") {
          this.filterStringOperation = 'IsLessThan';
        }
        if (this.advancedSearchAll.aRunwayLengthMf == "5") {
          this.filterStringOperation = 'IsLessThanOrEqualTo';
        }

        //this.apiRequest.filterItems.push(new FilterItems("RunwayLength", this.filterOperation, "Integer", this.advancedSearchAll.runwayLength));
        filterPredicateRunwayLength = [new FilterPredicate('RunwayLength', 'Integer', this.advancedSearchAll.runwayLength, this.filterStringOperation)];
        filterCompositArray.push(new FilterComposit(filterPredicateRunwayLength, 'Or'));
      }
      if (this.advancedSearchAll.baseRunwayElevation) {
        if (this.advancedSearchAll.aPhysicalElevOperator == ">") {
          this.filterStringOperation = 'IsGreaterThanOrEqualTo';
        }
        if (this.advancedSearchAll.aPhysicalElevOperator == "<") {
          this.filterStringOperation = 'IsLessThanOrEqualTo';
        }
        //this.apiRequest.filterItems.push(new FilterItems("BaseRunwayElevation", this.filterOperation, "Integer", this.advancedSearchAll.baseRunwayElevation));
        filterPredicateBaseRunwayElevation = [new FilterPredicate('BaseRunwayElevation', 'Integer', this.advancedSearchAll.baseRunwayElevation, this.filterStringOperation)];
        filterCompositArray.push(new FilterComposit(filterPredicateBaseRunwayElevation, 'Or'));
      }

      if (this.advancedSearchAll.runwayWidth) {
        if (this.advancedSearchAll.aRunwayWidthMf == '1') {
          this.filterStringOperation = 'IsEqualTo';
        }
        if (this.advancedSearchAll.aRunwayWidthMf == '2') {
          this.filterStringOperation = 'IsGreaterThan';
        }
        if (this.advancedSearchAll.aRunwayWidthMf == '3') {
          this.filterStringOperation = 'IsGreaterThanOrEqualTo';
        }
        if (this.advancedSearchAll.aRunwayWidthMf == '4') {
          this.filterStringOperation = 'IsLessThan';
        }
        if (this.advancedSearchAll.aRunwayWidthMf == '5') {
          this.filterStringOperation = 'IsLessThanOrEqualTo';
        }

        filterPredicateRunwayWidth = [new FilterPredicate('RunwayWidth', 'Integer', this.advancedSearchAll.runwayWidth,this.filterStringOperation)];
        filterCompositArray.push(new FilterComposit(filterPredicateRunwayWidth, 'Or'));
      }
      if (this.advancedSearchAll.surfaceTypeCondition) {
        //this.apiRequest.filterItems.push(new FilterItems("SurfaceTypeCondition", 8, "String", this.advancedSearchAll.surfaceTypeCondition));
        filterPredicateSurfaceTypeCondition = [new FilterPredicate('SurfaceTypeCondition', 'String', this.advancedSearchAll.surfaceTypeCondition,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateSurfaceTypeCondition, 'Or'));
      }
      //dropdown fields
      if (this.advancedSearchAll.baseFar77CategoryDesc) {
        //this.apiRequest.filterItems.push(new FilterItems("BaseFar77CategoryDesc", 8, "String", this.advancedSearchAll.baseFar77CategoryDesc));
        filterPredicateBaseFar77CategoryDesc = [new FilterPredicate('BaseFar77CategoryDesc', 'String', this.advancedSearchAll.baseFar77CategoryDesc,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateBaseFar77CategoryDesc, 'Or'));
      }
      if (this.advancedSearchAll.baseCloseInObstruction) {
        //this.apiRequest.filterItems.push(new FilterItems("BaseCloseInObstruction", 8, "String", this.advancedSearchAll.baseCloseInObstruction));
        filterPredicateBaseCloseInObstruction = [new FilterPredicate('BaseCloseInObstruction', 'String', this.advancedSearchAll.baseCloseInObstruction,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateBaseCloseInObstruction, 'Or'));
      }
      if (this.advancedSearchAll.baseRwyMarkingTypeDesc) {
        //this.apiRequest.filterItems.push(new FilterItems("BaseRwyMarkingTypeDesc", 8, "String", this.advancedSearchAll.baseRwyMarkingTypeDesc));
        filterPredicateBaseRwyMarkingTypeDesc = [new FilterPredicate('BaseRwyMarkingTypeDesc', 'String', this.advancedSearchAll.baseRwyMarkingTypeDesc,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateBaseRwyMarkingTypeDesc, 'Or'));
      }

      if (this.advancedSearchAll.baseRwyMarkingCondition) {
        //this.apiRequest.filterItems.push(new FilterItems("BaseRwyMarkingCondition", 8, "String", this.advancedSearchAll.baseRwyMarkingCondition));
        filterPredicateBaseRwyMarkingCondition = [new FilterPredicate('BaseRwyMarkingCondition', 'String', this.advancedSearchAll.baseRwyMarkingCondition,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateBaseRwyMarkingCondition, 'Or'));
      }
      if (this.advancedSearchAll.surfaceTreatmentDesc) {
        //this.apiRequest.filterItems.push(new FilterItems("SurfaceTreatmentDesc", 8, "String", this.advancedSearchAll.surfaceTreatmentDesc));
        filterPredicateSurfaceTreatmentDesc = [new FilterPredicate('SurfaceTreatmentDesc', 'String', this.advancedSearchAll.surfaceTreatmentDesc,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateSurfaceTreatmentDesc, 'Or'));
      }
      if (this.advancedSearchAll.unicom) {
        //this.apiRequest.filterItems.push(new FilterItems("Unicom", 8, "String", this.advancedSearchAll.unicom));
        filterPredicateUnicom = [new FilterPredicate('Unicom', 'String', this.advancedSearchAll.unicom,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateUnicom, 'Or'));
      }
      if (this.advancedSearchAll.ctrlTwr) {
        //this.apiRequest.filterItems.push(new FilterItems("CtrlTwr", 8, "String", this.advancedSearchAll.ctrlTwr));
        filterPredicateCtrlTwr = [new FilterPredicate('CtrlTwr', 'String', this.advancedSearchAll.ctrlTwr,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateCtrlTwr, 'Or'));
      }
      if (this.advancedSearchAll.npiasHubType) {
        //this.apiRequest.filterItems.push(new FilterItems("NpiasHubType", 8, "String", this.advancedSearchAll.npiasHubType));
        filterPredicateNpiasHubType = [new FilterPredicate('NpiasHubType', 'String', this.advancedSearchAll.npiasHubType,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateNpiasHubType, 'Or'));
      }
      if (this.advancedSearchAll.ado) {
        //this.apiRequest.filterItems.push(new FilterItems("Ado", 8, "String", this.advancedSearchAll.ado));
        filterPredicateAdo = [new FilterPredicate('Ado', 'String', this.advancedSearchAll.ado,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateAdo, 'Or'));
      }
      if (this.advancedSearchAll.part139) {
        //this.apiRequest.filterItems.push(new FilterItems("Part139", 8, "String", this.advancedSearchAll.part139));
        filterPredicatePart139 = [new FilterPredicate('Part139', 'String', this.advancedSearchAll.part139,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicatePart139, 'Or'));
      }
      if (this.advancedSearchAll.ownership) {
        //this.apiRequest.filterItems.push(new FilterItems("Ownership", 8, "String", this.advancedSearchAll.ownership));
        filterPredicateOwnership = [new FilterPredicate('Ownership', 'String', this.advancedSearchAll.ownership,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateOwnership, 'Or'));
      }
      if (this.advancedSearchAll.stateCode) {
        //this.apiRequest.filterItems.push(new FilterItems("StateCode", 8, "String", this.advancedSearchAll.stateCode));
        filterPredicateStateCode = [new FilterPredicate('StateCode', 'String', this.advancedSearchAll.stateCode,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateStateCode, 'Or'));
      }

      if (this.advancedSearchAll.airportUse) {
        //this.apiRequest.filterItems.push(new FilterItems("AirportUse", 8, "String", this.advancedSearchAll.airportUse));
        filterPredicateAirportUse = [new FilterPredicate('AirportUse', 'String', this.advancedSearchAll.airportUse,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateAirportUse, 'Or'));
      }

      if (this.advancedSearchAll.region) {
        //this.apiRequest.filterItems.push(new FilterItems("Region", 8, "String", this.advancedSearchAll.region));
        filterPredicateRegion = [new FilterPredicate('Region', 'String', this.advancedSearchAll.region,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateRegion, 'Or'));
      }

     if (this.advancedSearchAll.aSurfaceCondition ) {
        //this.apiRequest.filterItems.push(new FilterItems("SurfaceTypeCondition", 8, "String",this.advancedSearchAll.aSurfaceCondition));
        filterPredicateSurfaceCondition = [new FilterPredicate('SurfaceTypeCondition', 'String', this.advancedSearchAll.aSurfaceCondition,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateSurfaceCondition, 'Or'));
      }
   // CheckBoxes ---------------------------------------------------------------------------------------------------------------------------------
    filterPredicateASSETRank = [];

    if (this.advancedSearchAll.national ) {
      //this.apiRequest.filterItems.push(new FilterItems("ASSETRank", 8, "String","National"));
      filterPredicateASSETRank.push(new FilterPredicate('ASSETRank', 'String', "1 National",'IsEqualTo'));
    }
    if (this.advancedSearchAll.regional ) {
      //this.apiRequest.filterItems.push(new FilterItems("ASSETRank", 8, "String","Regional"));
      filterPredicateASSETRank.push(new FilterPredicate('ASSETRank', 'String', "2 Regional",'IsEqualTo'));
    }
    if (this.advancedSearchAll.local ) {
      //this.apiRequest.filterItems.push(new FilterItems("ASSETRank", 8, "String","Local"));
      filterPredicateASSETRank.push(new FilterPredicate('ASSETRank', 'String', "3 Local",'IsEqualTo'));
    }
    if (this.advancedSearchAll.basic ) {
      //this.apiRequest.filterItems.push(new FilterItems("ASSETRank", 8, "String","Basic"));
      filterPredicateASSETRank.push(new FilterPredicate('ASSETRank', 'String', "4 Basic",'IsEqualTo'));
    }
    if (this.advancedSearchAll.unclassified ) {
      //this.apiRequest.filterItems.push(new FilterItems("ASSETRank", 8, "String","Unclassified"));
      filterPredicateASSETRank.push(new FilterPredicate('ASSETRank', 'String', "5 Unclassified",'IsEqualTo'));
    }

    if (this.advancedSearchAll.national || this.advancedSearchAll.regional || this.advancedSearchAll.local || this.advancedSearchAll.basic || this.advancedSearchAll.unclassified) {
      filterCompositArray.push(new FilterComposit(filterPredicateASSETRank, 'Or'));
    }

    //NPIAS Service Level
    filterPredicateServiceLevel = [];
    if (this.advancedSearchAll.nonNpias ) {
      filterPredicateServiceLevel.push(new FilterPredicate('ServiceLevelName', 'String', "Non-NPIAS",'IsEqualTo'));
    }
    if (this.advancedSearchAll.commercialService ) {
      filterPredicateServiceLevel.push(new FilterPredicate('ServiceLevelName', 'String', "Commercial Service",'IsEqualTo'));
    }
    if (this.advancedSearchAll.primary ) {
      filterPredicateServiceLevel.push(new FilterPredicate('ServiceLevelName', 'String', "Primary",'IsEqualTo'));
    }
    if (this.advancedSearchAll.reliever ) {
      filterPredicateServiceLevel.push(new FilterPredicate('ServiceLevelName', 'String', "Reliever",'IsEqualTo'));
    }
    if (this.advancedSearchAll.generalAvaition ) {
      filterPredicateServiceLevel.push(new FilterPredicate('ServiceLevelName', 'String', "General Aviation",'IsEqualTo'));
    }

    if (this.advancedSearchAll.nonNpias || this.advancedSearchAll.commercialService || this.advancedSearchAll.primary || this.advancedSearchAll.reliever || this.advancedSearchAll.generalAvaition) {
      filterCompositArray.push(new FilterComposit(filterPredicateServiceLevel, 'Or'));
    }



      this.apiRequest.filter = new Filter(filterCompositArray, 'And');
      sortConditionArray = [new SortCondition('AirportName', 'Ascending')];
      this.apiRequest.sort = new Sort(sortConditionArray);

      this.apiRequest.pageInfo = new PageInfo(0, 1, 100000);


      if (this.advancedSearchAll.surfaceTypeHard === "1") {
        this.airportAdvancedSearch
          .getMultiple(this.apiRequest)
          .subscribe(result => {

            this.items = result.data;

            this.items = removeDuplicates(this.items, "airportIdentifier");
            this.totalRecords = this.items.length;
          });
      }

      if (this.advancedSearchAll.surfaceTypeHard === "2") {
        this.airportHardSurfaceOnly
          .getMultiple(this.apiRequest)
          .subscribe(result => {

            this.items = result.data;

            this.items = removeDuplicates(this.items, "airportIdentifier");
            this.totalRecords = this.items.length;
          });
      }

      if (this.advancedSearchAll.surfaceTypeHard === "3") {
        this.airportExcludeHardSurface
          .getMultiple(this.apiRequest)
          .subscribe(result => {

            this.items = result.data;
            this.items = removeDuplicates(this.items, "airportIdentifier");
            this.totalRecords = this.items.length;
          });
      }
  }

  onSearch() {

    this.errormsg="";
    this.validateForm();

    if (this.errormsg.length === 0) {
      this.showSearch = false;
      this.showGrid = false;

      this.apiRequest = new ApiRequest();
      //this.apiRequest.filter = new Filter("And");
      //this.apiRequest.filterItems = [];
      var filterPredicateAirportIdentifier: Array<FilterPredicate>;
      var filterPredicateAirportName: Array<FilterPredicate>;
      var filterPredicateAssociatedCity: Array<FilterPredicate>;
      var filterPredicateFUEL: Array<FilterPredicate>;
      var filterPredicateOtherServices: Array<FilterPredicate>;
      var filterPredicateBased: Array<FilterPredicate>;
      var filterPredicateOperationsTotal: Array<FilterPredicate>;
      var filterPredicateRunwayLength: Array<FilterPredicate>;
      var filterPredicateBaseRunwayElevation: Array<FilterPredicate>;
      var filterPredicateRunwayWidth: Array<FilterPredicate>;
      var filterPredicateSurfaceTypeCondition: Array<FilterPredicate>;
      var filterPredicateBaseFar77CategoryDesc: Array<FilterPredicate>;
      var filterPredicateBaseCloseInObstruction: Array<FilterPredicate>;
      var filterPredicateBaseRwyMarkingTypeDesc: Array<FilterPredicate>;
      var filterPredicateBaseRwyMarkingCondition: Array<FilterPredicate>;
      var filterPredicateSurfaceTreatmentDesc: Array<FilterPredicate>;
      var filterPredicateUnicom: Array<FilterPredicate>;
      var filterPredicateCtrlTwr: Array<FilterPredicate>;
      var filterPredicateNpiasHubType: Array<FilterPredicate>;
      var filterPredicateAdo: Array<FilterPredicate>;
      var filterPredicatePart139: Array<FilterPredicate>;
      var filterPredicateOwnership: Array<FilterPredicate>;
      var filterPredicateStateCode: Array<FilterPredicate>;
      var filterPredicateAirportUse: Array<FilterPredicate>;
      var filterPredicateRegion: Array<FilterPredicate>;
      var filterPredicateSurfaceCondition: Array<FilterPredicate>;
      var filterPredicateASSETRank: Array<FilterPredicate>;
      var filterPredicateServiceLevel: Array<FilterPredicate>;
      var filterCompositArray: Array<FilterComposit>;
      var sortConditionArray: Array<SortCondition>;

      // input fields
      filterCompositArray = [];
      if (this.advancedSearchAll.airportIdentifier) {
        //this.apiRequest.filterItems.push(new FilterItems("AirportIdentifier", 8, "String", this.advancedSearchAll.airportIdentifier));
        filterPredicateAirportIdentifier = [new FilterPredicate('AirportIdentifier', 'String', this.advancedSearchAll.airportIdentifier,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateAirportIdentifier, 'Or'));
      }

      if (this.advancedSearchAll.airportName) {
        //this.apiRequest.filterItems.push(new FilterItems("AirportName", 8, "String",this.advancedSearchAll.airportName));
        filterPredicateAirportName = [new FilterPredicate('AirportName', 'String', this.advancedSearchAll.airportName,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateAirportName, 'Or'));
      }

      if (this.advancedSearchAll.associatedCity) {
        //this.apiRequest.filterItems.push(new FilterItems("AssociatedCity", 8, "String", this.advancedSearchAll.associatedCity));
        filterPredicateAssociatedCity = [new FilterPredicate('AssociatedCity', 'String', this.advancedSearchAll.associatedCity,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateAssociatedCity, 'Or'));
      }
      if (this.advancedSearchAll.fuel) {
        //this.apiRequest.filterItems.push(new FilterItems("FUEL", 8, "String", this.advancedSearchAll.fuel));
        filterPredicateFUEL = [new FilterPredicate('FUEL', 'String', this.advancedSearchAll.fuel,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateFUEL, 'Or'));
      }
      if (this.advancedSearchAll.otherServices) {
        //this.apiRequest.filterItems.push(new FilterItems("OtherServices", 8, "String", this.advancedSearchAll.otherServices));
        filterPredicateOtherServices = [new FilterPredicate('OtherServices', 'String', this.advancedSearchAll.otherServices,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateOtherServices, 'Or'));
      }
      if (this.advancedSearchAll.based) {
        if (this.advancedSearchAll.aBasedMf == "1") {
          this.filterStringOperation = 'IsEqualTo';
        }
        if (this.advancedSearchAll.aBasedMf == "2") {
          this.filterStringOperation = 'IsGreaterThan';
        }
        if (this.advancedSearchAll.aBasedMf == "3") {
          this.filterStringOperation = 'IsGreaterThanOrEqualTo';
        }
        if (this.advancedSearchAll.aBasedMf == "4") {
          this.filterStringOperation = 'IsLessThan';
        }
        if (this.advancedSearchAll.aBasedMf == "5") {
          this.filterStringOperation = 'IsLessThanOrEqualTo';
        }
        //this.apiRequest.filterItems.push(new FilterItems("Based", this.filterOperation, "Integer", this.advancedSearchAll.based));
        filterPredicateBased = [new FilterPredicate('Based', 'Integer', this.advancedSearchAll.based, this.filterStringOperation)];
        filterCompositArray.push(new FilterComposit(filterPredicateBased, 'Or'));
      }
      if (this.advancedSearchAll.operationsTotal) {
        if (this.advancedSearchAll.aOperationsMf == "1") {
          this.filterStringOperation = 'IsEqualTo';
        }
        if (this.advancedSearchAll.aOperationsMf == "2") {
          this.filterStringOperation = 'IsGreaterThan';
        }
        if (this.advancedSearchAll.aOperationsMf == "3") {
          this.filterStringOperation = 'IsGreaterThanOrEqualTo';
        }
        if (this.advancedSearchAll.aOperationsMf == "4") {
          this.filterStringOperation = 'IsLessThan';
        }
        if (this.advancedSearchAll.aOperationsMf == "5") {
          this.filterStringOperation = 'IsLessThanOrEqualTo';
        }
        //this.apiRequest.filterItems.push(new FilterItems("OperationsTotal", this.filterOperation, "Integer", this.advancedSearchAll.operationsTotal));
        filterPredicateOperationsTotal = [new FilterPredicate('OperationsTotal', 'Integer', this.advancedSearchAll.operationsTotal, this.filterStringOperation)];
        filterCompositArray.push(new FilterComposit(filterPredicateOperationsTotal, 'Or'));
      }
      if (this.advancedSearchAll.runwayLength) {
        if (this.advancedSearchAll.aRunwayLengthMf == "1") {
          this.filterStringOperation = 'IsEqualTo';
        }
        if (this.advancedSearchAll.aRunwayLengthMf == "2") {
          this.filterStringOperation = 'IsGreaterThan';
        }
        if (this.advancedSearchAll.aRunwayLengthMf == "3") {
          this.filterStringOperation = 'IsGreaterThanOrEqualTo';
        }
        if (this.advancedSearchAll.aRunwayLengthMf == "4") {
          this.filterStringOperation = 'IsLessThan';
        }
        if (this.advancedSearchAll.aRunwayLengthMf == "5") {
          this.filterStringOperation = 'IsLessThanOrEqualTo';
        }

        //this.apiRequest.filterItems.push(new FilterItems("RunwayLength", this.filterOperation, "Integer", this.advancedSearchAll.runwayLength));
        filterPredicateRunwayLength = [new FilterPredicate('RunwayLength', 'Integer', this.advancedSearchAll.runwayLength, this.filterStringOperation)];
        filterCompositArray.push(new FilterComposit(filterPredicateRunwayLength, 'Or'));
      }
      if (this.advancedSearchAll.baseRunwayElevation) {
        if (this.advancedSearchAll.aPhysicalElevOperator == ">") {
          this.filterStringOperation = 'IsGreaterThanOrEqualTo';
        }
        if (this.advancedSearchAll.aPhysicalElevOperator == "<") {
          this.filterStringOperation = 'IsLessThanOrEqualTo';
        }
        //this.apiRequest.filterItems.push(new FilterItems("BaseRunwayElevation", this.filterOperation, "Integer", this.advancedSearchAll.baseRunwayElevation));
        filterPredicateBaseRunwayElevation = [new FilterPredicate('BaseRunwayElevation', 'Integer', this.advancedSearchAll.baseRunwayElevation, this.filterStringOperation)];
        filterCompositArray.push(new FilterComposit(filterPredicateBaseRunwayElevation, 'Or'));
      }

      if (this.advancedSearchAll.runwayWidth) {
        if (this.advancedSearchAll.aRunwayWidthMf == '1') {
          this.filterStringOperation = 'IsEqualTo';
        }
        if (this.advancedSearchAll.aRunwayWidthMf == '2') {
          this.filterStringOperation = 'IsGreaterThan';
        }
        if (this.advancedSearchAll.aRunwayWidthMf == '3') {
          this.filterStringOperation = 'IsGreaterThanOrEqualTo';
        }
        if (this.advancedSearchAll.aRunwayWidthMf == '4') {
          this.filterStringOperation = 'IsLessThan';
        }
        if (this.advancedSearchAll.aRunwayWidthMf == '5') {
          this.filterStringOperation = 'IsLessThanOrEqualTo';
        }

        filterPredicateRunwayWidth = [new FilterPredicate('RunwayWidth', 'Integer', this.advancedSearchAll.runwayWidth,this.filterStringOperation)];
        filterCompositArray.push(new FilterComposit(filterPredicateRunwayWidth, 'Or'));
      }
      if (this.advancedSearchAll.surfaceTypeCondition) {
        //this.apiRequest.filterItems.push(new FilterItems("SurfaceTypeCondition", 8, "String", this.advancedSearchAll.surfaceTypeCondition));
        filterPredicateSurfaceTypeCondition = [new FilterPredicate('SurfaceTypeCondition', 'String', this.advancedSearchAll.surfaceTypeCondition,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateSurfaceTypeCondition, 'Or'));
      }
      //dropdown fields
      if (this.advancedSearchAll.baseFar77CategoryDesc) {
        //this.apiRequest.filterItems.push(new FilterItems("BaseFar77CategoryDesc", 8, "String", this.advancedSearchAll.baseFar77CategoryDesc));
        filterPredicateBaseFar77CategoryDesc = [new FilterPredicate('BaseFar77CategoryDesc', 'String', this.advancedSearchAll.baseFar77CategoryDesc,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateBaseFar77CategoryDesc, 'Or'));
      }
      if (this.advancedSearchAll.baseCloseInObstruction) {
        //this.apiRequest.filterItems.push(new FilterItems("BaseCloseInObstruction", 8, "String", this.advancedSearchAll.baseCloseInObstruction));
        filterPredicateBaseCloseInObstruction = [new FilterPredicate('BaseCloseInObstruction', 'String', this.advancedSearchAll.baseCloseInObstruction,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateBaseCloseInObstruction, 'Or'));
      }
      if (this.advancedSearchAll.baseRwyMarkingTypeDesc) {
        //this.apiRequest.filterItems.push(new FilterItems("BaseRwyMarkingTypeDesc", 8, "String", this.advancedSearchAll.baseRwyMarkingTypeDesc));
        filterPredicateBaseRwyMarkingTypeDesc = [new FilterPredicate('BaseRwyMarkingTypeDesc', 'String', this.advancedSearchAll.baseRwyMarkingTypeDesc,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateBaseRwyMarkingTypeDesc, 'Or'));
      }

      if (this.advancedSearchAll.baseRwyMarkingCondition) {
        //this.apiRequest.filterItems.push(new FilterItems("BaseRwyMarkingCondition", 8, "String", this.advancedSearchAll.baseRwyMarkingCondition));
        filterPredicateBaseRwyMarkingCondition = [new FilterPredicate('BaseRwyMarkingCondition', 'String', this.advancedSearchAll.baseRwyMarkingCondition,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateBaseRwyMarkingCondition, 'Or'));
      }
      if (this.advancedSearchAll.surfaceTreatmentDesc) {
        //this.apiRequest.filterItems.push(new FilterItems("SurfaceTreatmentDesc", 8, "String", this.advancedSearchAll.surfaceTreatmentDesc));
        filterPredicateSurfaceTreatmentDesc = [new FilterPredicate('SurfaceTreatmentDesc', 'String', this.advancedSearchAll.surfaceTreatmentDesc,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateSurfaceTreatmentDesc, 'Or'));
      }
      if (this.advancedSearchAll.unicom) {
        //this.apiRequest.filterItems.push(new FilterItems("Unicom", 8, "String", this.advancedSearchAll.unicom));
        filterPredicateUnicom = [new FilterPredicate('Unicom', 'String', this.advancedSearchAll.unicom,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateUnicom, 'Or'));
      }
      if (this.advancedSearchAll.ctrlTwr) {
        //this.apiRequest.filterItems.push(new FilterItems("CtrlTwr", 8, "String", this.advancedSearchAll.ctrlTwr));
        filterPredicateCtrlTwr = [new FilterPredicate('CtrlTwr', 'String', this.advancedSearchAll.ctrlTwr,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateCtrlTwr, 'Or'));
      }
      if (this.advancedSearchAll.npiasHubType) {
        //this.apiRequest.filterItems.push(new FilterItems("NpiasHubType", 8, "String", this.advancedSearchAll.npiasHubType));
        filterPredicateNpiasHubType = [new FilterPredicate('NpiasHubType', 'String', this.advancedSearchAll.npiasHubType,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateNpiasHubType, 'Or'));
      }
      if (this.advancedSearchAll.ado) {
        //this.apiRequest.filterItems.push(new FilterItems("Ado", 8, "String", this.advancedSearchAll.ado));
        filterPredicateAdo = [new FilterPredicate('Ado', 'String', this.advancedSearchAll.ado,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateAdo, 'Or'));
      }
      if (this.advancedSearchAll.part139) {
        //this.apiRequest.filterItems.push(new FilterItems("Part139", 8, "String", this.advancedSearchAll.part139));
        filterPredicatePart139 = [new FilterPredicate('Part139', 'String', this.advancedSearchAll.part139,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicatePart139, 'Or'));
      }
      if (this.advancedSearchAll.ownership) {
        //this.apiRequest.filterItems.push(new FilterItems("Ownership", 8, "String", this.advancedSearchAll.ownership));
        filterPredicateOwnership = [new FilterPredicate('Ownership', 'String', this.advancedSearchAll.ownership,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateOwnership, 'Or'));
      }
      if (this.advancedSearchAll.stateCode) {
        //this.apiRequest.filterItems.push(new FilterItems("StateCode", 8, "String", this.advancedSearchAll.stateCode));
        filterPredicateStateCode = [new FilterPredicate('StateCode', 'String', this.advancedSearchAll.stateCode,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateStateCode, 'Or'));
      }

      if (this.advancedSearchAll.airportUse) {
        //this.apiRequest.filterItems.push(new FilterItems("AirportUse", 8, "String", this.advancedSearchAll.airportUse));
        filterPredicateAirportUse = [new FilterPredicate('AirportUse', 'String', this.advancedSearchAll.airportUse,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateAirportUse, 'Or'));
      }

      if (this.advancedSearchAll.region) {
        //this.apiRequest.filterItems.push(new FilterItems("Region", 8, "String", this.advancedSearchAll.region));
        filterPredicateRegion = [new FilterPredicate('Region', 'String', this.advancedSearchAll.region,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateRegion, 'Or'));
      }

     if (this.advancedSearchAll.aSurfaceCondition ) {
        //this.apiRequest.filterItems.push(new FilterItems("SurfaceTypeCondition", 8, "String",this.advancedSearchAll.aSurfaceCondition));
        filterPredicateSurfaceCondition = [new FilterPredicate('SurfaceTypeCondition', 'String', this.advancedSearchAll.aSurfaceCondition,'IsEqualTo')];
        filterCompositArray.push(new FilterComposit(filterPredicateSurfaceCondition, 'Or'));
      }
   // CheckBoxes ---------------------------------------------------------------------------------------------------------------------------------
    filterPredicateASSETRank = [];

    if (this.advancedSearchAll.national ) {
      //this.apiRequest.filterItems.push(new FilterItems("ASSETRank", 8, "String","National"));
      filterPredicateASSETRank.push(new FilterPredicate('ASSETRank', 'String', "1 National",'IsEqualTo'));
    }
    if (this.advancedSearchAll.regional ) {
      //this.apiRequest.filterItems.push(new FilterItems("ASSETRank", 8, "String","Regional"));
      filterPredicateASSETRank.push(new FilterPredicate('ASSETRank', 'String', "2 Regional",'IsEqualTo'));
    }
    if (this.advancedSearchAll.local ) {
      //this.apiRequest.filterItems.push(new FilterItems("ASSETRank", 8, "String","Local"));
      filterPredicateASSETRank.push(new FilterPredicate('ASSETRank', 'String', "3 Local",'IsEqualTo'));
    }
    if (this.advancedSearchAll.basic ) {
      //this.apiRequest.filterItems.push(new FilterItems("ASSETRank", 8, "String","Basic"));
      filterPredicateASSETRank.push(new FilterPredicate('ASSETRank', 'String', "4 Basic",'IsEqualTo'));
    }
    if (this.advancedSearchAll.unclassified ) {
      //this.apiRequest.filterItems.push(new FilterItems("ASSETRank", 8, "String","Unclassified"));
      filterPredicateASSETRank.push(new FilterPredicate('ASSETRank', 'String', "5 Unclassified",'IsEqualTo'));
    }

    if (this.advancedSearchAll.national || this.advancedSearchAll.regional || this.advancedSearchAll.local || this.advancedSearchAll.basic || this.advancedSearchAll.unclassified) {
      filterCompositArray.push(new FilterComposit(filterPredicateASSETRank, 'Or'));
    }

    //NPIAS Service Level
    filterPredicateServiceLevel = [];
    if (this.advancedSearchAll.nonNpias ) {
      filterPredicateServiceLevel.push(new FilterPredicate('ServiceLevelName', 'String', "Non-NPIAS",'IsEqualTo'));
    }
    if (this.advancedSearchAll.commercialService ) {
      filterPredicateServiceLevel.push(new FilterPredicate('ServiceLevelName', 'String', "Commercial Service",'IsEqualTo'));
    }
    if (this.advancedSearchAll.primary ) {
      filterPredicateServiceLevel.push(new FilterPredicate('ServiceLevelName', 'String', "Primary",'IsEqualTo'));
    }
    if (this.advancedSearchAll.reliever ) {
      filterPredicateServiceLevel.push(new FilterPredicate('ServiceLevelName', 'String', "Reliever",'IsEqualTo'));
    }
    if (this.advancedSearchAll.generalAvaition ) {
      filterPredicateServiceLevel.push(new FilterPredicate('ServiceLevelName', 'String', "General Aviation",'IsEqualTo'));
    }

    if (this.advancedSearchAll.nonNpias || this.advancedSearchAll.commercialService || this.advancedSearchAll.primary || this.advancedSearchAll.reliever || this.advancedSearchAll.generalAvaition) {
      filterCompositArray.push(new FilterComposit(filterPredicateServiceLevel, 'Or'));
    }



      this.apiRequest.filter = new Filter(filterCompositArray, 'And');
      sortConditionArray = [new SortCondition('AirportName', 'Ascending')];
      this.apiRequest.sort = new Sort(sortConditionArray);

      this.apiRequest.pageInfo = new PageInfo(0, 1, 100000);


      if (this.advancedSearchAll.surfaceTypeHard === "1") {
        this.airportAdvancedSearch
          .getMultiple(this.apiRequest)
          .subscribe(result => {

            this.items = result.data;

            this.items = removeDuplicates(this.items, "airportIdentifier");
            this.loadItems();
            this.exportConversion();
            this.showGrid=true;
          });

      }

      if (this.advancedSearchAll.surfaceTypeHard === "2") {
        this.airportHardSurfaceOnly
          .getMultiple(this.apiRequest)
          .subscribe(result => {

            this.items = result.data;

            this.items = removeDuplicates(this.items, "airportIdentifier");
            this.loadItems();
            this.exportConversion();
            this.showGrid=true;
          });

      }

      if (this.advancedSearchAll.surfaceTypeHard === "3") {
        this.airportExcludeHardSurface
          .getMultiple(this.apiRequest)
          .subscribe(result => {

            this.items = result.data;
            this.items = removeDuplicates(this.items, "airportIdentifier");
            this.loadItems();
            this.exportConversion();
            this.showGrid=true;
          });

      }
    }
  }

  public exportConversion(): void {


    for (let i of this.items) {
      let s = new AdvancedSearchExport();
      s.Id = i.id;
      s.Faa_Site = i.faaSite;
      s.Loc_Id = i.airportIdentifier;
      s.Airport_Name = i.airportName;
      s.Associated_City = i.associatedCity;
      s.Region = i.region;
      s.Ado = i.ado;
      s.Airport_Use = i.airportUse;
      s.Latitude = i.arptLat;
      s.Longitude = i.arptLong;
      s.Airport_Ownership = i.ownership;
      s.Part139 = i.part139;
      s.NPIAS_Service_Level = i.serviceLevelName;
      s.NPIAS_Hub_Type = i.npiasHubType;
      s.Control_Tower = i.ctrlTwr;
      s.Fuel = i.fuel;
      s.Other_Services = i.otherServices;
      s.Based_Aircraft_Total = i.based;
      s.Total_Operations = i.operationsTotal;
      s.Asset_Role = i.assetRank;
      s.Elevation = i.arptElev;
      s.OwnerName = i.owner;
      s.OwnerAddress = i.ownerAddress;
      s.OwnerCityStZip = i.ownerAddressCsz;
      s.OwnerPhone = i.ownerPhone;
      s.ManagerName = i.manager;
      s.ManagerAddress = i.managerAddress;
      s.ManagerCityStZip = i.managerAddressCsz;
      s.ManagerPhone = i.managerPhone;
      s.RunwayLength = i.runwayLength;
      s.RunwayWidth = i.runwayWidth;

      //this.apiRequest.filterItems.push(new FilterItems("ASSETRank", 8, "String","Unclassified"));
      //public exportItems: AdvancedSearchExport[] = null;
      this.exportItems.push(s);


    }

  }



  public exportAsXLSX():void {
    this.exportItemsNoDups = removeDuplicates(this.exportItems, "Loc_Id");
    let var1 :any[] =this.exportItemsNoDups;
    this.excelService.exportAsExcelFile(var1, 'AirportIq5010');
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.loadItems();
}
  private loadItems(): void {
    this.gridView = {
      data: this.items.slice(this.skip, this.skip + this.pageSize),
      total: this.items.length
    };
  }
  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.loaditemsforsorting();
}
private loaditemsforsorting(): void {
  this.gridView = {
      data: orderBy(this.items, this.sort),
      total: this.items.length
  };
}

  public cellClickHandler({ sender, rowIndex, columnIndex, dataItem, isEdited }) {
    if (columnIndex < 9) {
      this.cas.setCurrentAirport(dataItem.airportIdentifier);
      this.router.navigate(['\dashboard']);
    }
  }

  onReset() {
    //validation error msg initialization

    this.errormsg = "";
    this.totalRecords = 0;
    // input fields

    this.advancedSearchAll.airportIdentifier = "";
    this.advancedSearchAll.airportName = "";
    this.advancedSearchAll.associatedCity = "";
    this.advancedSearchAll.fuel = "";
    this.advancedSearchAll.otherServices = "";
    this.advancedSearchAll.based = "";
    this.advancedSearchAll.operationsTotal = "";
    this.advancedSearchAll.runwayLength = "";
    this.advancedSearchAll.baseRunwayElevation = "";
    this.advancedSearchAll.runwayWidth = "";
    this.advancedSearchAll.surfaceTypeCondition = "";

    //dropdown fields
    this.advancedSearchAll.aPhysicalElevOperator = "";
    this.advancedSearchAll.baseFar77CategoryDesc = "";
    this.advancedSearchAll.baseCloseInObstruction = "";
    this.advancedSearchAll.baseRwyMarkingTypeDesc = "";
    this.advancedSearchAll.baseRwyMarkingCondition = "";
    this.advancedSearchAll.surfaceTreatmentDesc = "";
    this.advancedSearchAll.unicom = "";
    this.advancedSearchAll.ctrlTwr = "";
    this.advancedSearchAll.npiasHubType = "";
    this.advancedSearchAll.ado = "";
    this.advancedSearchAll.part139 = "";
    this.advancedSearchAll.ownership = "";
    this.advancedSearchAll.stateCode = "";
    this.advancedSearchAll.airportUse = "";
    this.advancedSearchAll.surfaceTypeHard = '1';
    this.advancedSearchAll.aBasedMf = '0';
    this.advancedSearchAll.aOperationsMf = "0";
    this.advancedSearchAll.aRunwayLengthMf = "0";
    this.advancedSearchAll.aRunwayWidthMf = "0";
    this.advancedSearchAll.region = "";
    this.advancedSearchAll.aSurfaceCondition = "";

    //Checkbox fields
    this.advancedSearchAll.ownerInfo = "";
    this.advancedSearchAll.managerInfo = "";
    this.advancedSearchAll.nonNpias = "";
    this.advancedSearchAll.commercialService = "";
    this.advancedSearchAll.primary = "";
    this.advancedSearchAll.reliever = "";
    this.advancedSearchAll.generalAvaition = "";
    this.advancedSearchAll.national = "";
    this.advancedSearchAll.regional = "";
    this.advancedSearchAll.local = "";
    this.advancedSearchAll.basic = "";
    this.advancedSearchAll.unclassified = "";
    this.userModified  = false;
  }
}


function removeDuplicates(myArr, prop) {
  if (myArr) {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    })
  };
}
